import React from 'react'

function NoData({title}) {
    return (
        <div className="text-center w-100 h-100 d-flex py-2 align-items-center justify-content-center text-muted mt-4">
            <img src="/assets/images/not-found.svg" style={{width:"250px"}} className="img-fluid " />
            {title||""}
        </div>
    )
}

export default NoData
